__turbopack_context__.v({
  "introsection": "IntroSection-module-scss-module__GiNpiq__introsection",
  "videocontainer": "IntroSection-module-scss-module__GiNpiq__videocontainer",
});
